var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expats-page"},[_c('life-abroad-header'),_vm._v(" "),_c('welcome-to-czech'),_vm._v(" "),_c('prague-banner'),_vm._v(" "),_c('brno-banner'),_vm._v(" "),_c('section',{staticClass:"section-resting"}),_vm._v(" "),_c('bonus-grid'),_vm._v(" "),_c('image-banner'),_vm._v(" "),_c('featured-roles')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29c51c26","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ExpatsPage.vue
// module id = null
// module chunks = 